// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"85db9723","977":"32c11c27"}[chunkId] + ".chunk.js";
};